import { useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";

const menu = [
  { name: "Home", route: "/", icon: "🏠" },
 { name: "Dashboard", route: "/dashboard", icon: "📊" },
  { name: "Compiler", route: "/compiler", icon: "💻" },
  { name: "Courses", route: "/courses", icon: "📚" },
  { name: "Tests", route: "/tests", icon: "📝" },
  { name: "Labs", route: "/labs", icon: "🧪" },
  { name: "Leaderboard", route: "/leaderboard", icon: "🏆" },
  { name: "Logs", route: "/logs", icon: "📜" },
];

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div
      className={`
        fixed top-0 left-0 z-50 h-full
        ${collapsed ? "w-20" : "w-64"}
        bg-gradient-to-b from-gray-950 to-gray-900
        border-r border-gray-800
        text-gray-300 flex flex-col
        transition-all duration-300 ease-in-out
      `}
    >
      {/* ================= LOGO / TOGGLE ================= */}
  {/* ================= LOGO / TOGGLE ================= */}
<div className="px-4 py-5 flex items-center justify-between border-b border-gray-800">
  {!collapsed && (
    <div className="flex items-center gap-2">
 <img
  src="/logo.png"
  alt="StudyPortal Logo"
  className="
    w-12 h-12
    p-1.5
    rounded-2xl
    bg-white
    object-contain
    shadow-lg
    ring-2 ring-white/80
    transition
    duration-300
    hover:scale-105
  "
/>

      <span className="text-lg font-bold tracking-wide text-white">
        CodemintX
      </span>
    </div>
  )}

  <button
    onClick={() => setCollapsed(!collapsed)}
    className="text-gray-400 hover:text-white transition"
    title="Toggle Sidebar"
  >
    ☰
  </button>
</div>


      {/* ================= MENU ================= */}
      <div className="flex-1 px-2 py-4 space-y-1 overflow-y-auto">
        {menu.map((item) => {
          const active = location.pathname === item.route;

          return (
            <div
              key={item.name}
              onClick={() => navigate(item.route)}
              className={`
                group flex items-center gap-3
                px-3 py-3 rounded-xl cursor-pointer
                transition-all duration-200
                ${
                  active
                    ? "bg-blue-600/20 text-blue-400 shadow-inner border-l-4 border-blue-500"
                    : "hover:bg-gray-800 hover:text-white"
                }
              `}
            >
              <span
                className={`
                  text-xl transition
                  ${active ? "scale-110" : "group-hover:scale-110"}
                `}
              >
                {item.icon}
              </span>

              {!collapsed && (
                <span className="text-sm font-medium tracking-wide">
                  {item.name}
                </span>
              )}
            </div>
          );
        })}
      </div>

      {/* ================= FOOTER ================= */}
      <div className="px-4 py-3 text-xs text-gray-500 border-t border-gray-800">
        {!collapsed && (
          <div className="flex justify-between items-center">
            <span>© 2026 StudyPortal</span>
            <span className="text-blue-500 font-semibold">v1.0</span>
          </div>
        )}
      </div>
    </div>
  );
}
